













import Vue from 'vue';
import util from '@/components/util';

export default Vue.extend({
  name: 'ModalCancelOfContract',
  components: { ...util},
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    quit() {
      this.$emit('quit');
    },
  },
});
